import { _ as _defineProperty, a as _inherits, b as _createClass, c as _objectWithoutProperties, d as _objectSpread2, e as _classCallCheck, f as _callSuper } from '../_helpers/_rollupPluginBabelHelpers.js';
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import deprecate from 'util-deprecate';
import { Color, Size } from './icon__constants.js';
import { m as modules_29747b80, I as IconSVG } from '../_helpers/icon__svg.js';
import { jsx } from 'react/jsx-runtime';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.replace.js';
import 'core-js/modules/es.string.starts-with.js';
import '../global/memoize.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.map.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.weak-map.js';
import 'core-js/modules/web.dom-collections.iterator.js';

var _excluded = ["className", "size", "color", "loading", "glyph", "width", "height", "suppressSizeWarning"];
var _warnSize = deprecate(function () {}, "`size`, `width` and `height` props are not recommended to use in Ring UI `Icon` component. The intrinsic sizes of SVG icon (`width` and `height` SVG attributes) are used instead.\n\nWe strongly recommend to use icons handcrafted for particular sizes. If your icon doesn't exist in the desired size, please ask your designer to draw one. \"Responsive\" checkmark should be unchecked when exporting icon.'");
var Icon = /*#__PURE__*/function (_PureComponent) {
  function Icon() {
    _classCallCheck(this, Icon);
    return _callSuper(this, Icon, arguments);
  }
  _inherits(Icon, _PureComponent);
  return _createClass(Icon, [{
    key: "warnSize",
    value: function warnSize() {
      if (this.props.suppressSizeWarning) {
        return;
      }
      _warnSize();
    }
  }, {
    key: "getStyle",
    value: function getStyle() {
      var _this$props = this.props,
        size = _this$props.size,
        width = _this$props.width,
        height = _this$props.height;
      if (width || height) {
        this.warnSize();
        return {
          width,
          height
        };
      }
      if (size) {
        this.warnSize();
        return {
          width: size,
          height: size
        };
      }
      return undefined;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        className = _this$props2.className;
        _this$props2.size;
        var color = _this$props2.color,
        loading = _this$props2.loading,
        Glyph = _this$props2.glyph;
        _this$props2.width;
        _this$props2.height;
        _this$props2.suppressSizeWarning;
        var restProps = _objectWithoutProperties(_this$props2, _excluded);
      if (!Glyph) {
        return null;
      }
      var classes = classNames(modules_29747b80.icon, {
        [modules_29747b80[color]]: !!color,
        [modules_29747b80.loading]: loading
      }, className);
      return /*#__PURE__*/jsx("span", _objectSpread2(_objectSpread2({}, restProps), {}, {
        className: classes,
        children: typeof Glyph === 'string' ? /*#__PURE__*/jsx(IconSVG, {
          src: Glyph,
          style: this.getStyle()
        }) : /*#__PURE__*/jsx(Glyph, {
          className: modules_29747b80.glyph,
          style: this.getStyle()
        })
      }));
    }
  }]);
}(PureComponent);
_defineProperty(Icon, "propTypes", {
  className: PropTypes.string,
  color: PropTypes.string,
  glyph: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]).isRequired,
  height: PropTypes.number,
  size: PropTypes.number,
  width: PropTypes.number,
  loading: PropTypes.bool,
  suppressSizeWarning: PropTypes.bool
});
_defineProperty(Icon, "defaultProps", {
  className: '',
  color: Color.DEFAULT,
  glyph: ''
});
_defineProperty(Icon, "Color", Color);
_defineProperty(Icon, "Size", Size);

export { Color, Size, Icon as default };
